export default __webpack_public_path__ + "static/dot-pattern-46aeee08c8f9832a31295746c99c0b8a.svg";